export const AAM2_LEGACY_BASE_PATH = '/aam2'
export const AAM2_BASE_PATH = '/myyear'
export const MY_NAME_BASE_PATH = '/myname'
export const FAMOUS_RELATIVES_BASE_PATH = '/myfamousrelatives'
